import {
  Component,
  computed,
  effect,
  input,
  signal,
  output,
} from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styles: [],
  imports: [SvgIconComponent],
})
export class ToastComponent {
  position = input<'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'>(
    'bottom-right'
  );
  triggerToast = input(false);
  toastMessage = input('');
  toastTitle = input('');
  timeoutLength = input(1000);
  zIndexClass = input('z-50');
  actionLabel = input('');
  fullWidth = input(false);
  compact = input(false);
  hosted = input(false);
  persistent = input(false);
  snackbar = input(false);

  readonly closed = output<void>();
  readonly action = output<void>();

  toastVisible = signal(false);
  positionClasses = computed(() => {
    if (this.fullWidth() || this.snackbar()) {
      return 'bottom-4 left-0 right-0';
    }
    return {
      'bottom-left': 'bottom-4 left-2',
      'bottom-right': 'bottom-4 right-2',
      'top-left': 'top-4 left-2',
      'top-right': 'top-4 right-2',
    }[this.position()];
  });
  cardWidthClass = computed(() => {
    if (this.fullWidth() || this.snackbar()) return 'w-full';
    if (this.compact()) return 'w-auto max-w-[22.4375rem]';
    return 'w-[22.4375rem]';
  });
  titleWeightClass = computed(() =>
    this.fullWidth() ? 'font-normal' : 'font-semibold'
  );
  containerClasses = computed(() => {
    const gutter = this.snackbar() ? 'px-4' : 'px-2';
    if (this.hosted()) {
      return `relative ${this.zIndexClass()} ${gutter} pb-4 flex flex-col gap-2.5`;
    }
    return `fixed ${this.zIndexClass()} ${gutter} pb-4 flex flex-col gap-2.5 ${this.positionClasses()}`;
  });

  private toastTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    effect(() => {
      if (this.triggerToast()) {
        this.toastVisible.set(true);
        this.showToastWithTimeout(() => this.toastVisible.set(false));
      }
    });
  }

  hideToast() {
    this.toastVisible.set(false);
    if (this.toastTimeout) {
      clearTimeout(this.toastTimeout);
    }
    this.closed.emit();
  }

  onActionClick() {
    this.toastVisible.set(false);
    if (this.toastTimeout) {
      clearTimeout(this.toastTimeout);
    }
    this.action.emit();
  }

  private showToastWithTimeout(callback?: () => void) {
    if (this.toastTimeout) {
      clearTimeout(this.toastTimeout);
    }

    if (this.persistent()) {
      return;
    }

    this.toastTimeout = setTimeout(() => {
      this.toastTimeout = null;
      if (callback) {
        callback();
      }
      this.closed.emit();
    }, this.timeoutLength());
  }
}
